import React from 'react';
import PropTypes from 'prop-types';

const TextWithLinks = ({ text, links, className }) => {
  let updatedTxt = text;

  if (text && links) {
    const txtObj = text.split(/\[(.*?)\]/g);

    updatedTxt = txtObj.map((item, index) => {
      const link = links.filter((a) => a.id === item);
      if (link && link.length > 0) {
        const btnLink = link[0];

        if (btnLink.href) {
          return (
            <a key={`inline-link-${index}`} href={btnLink.href} target={btnLink.target || '_blank'} aria-label={btnLink.aria}>{btnLink.label}</a>
          );
        }

        if (btnLink.action) {
          return (<button key={`inline-button-${index}`} type="button" onClick={btnLink.action} aria-label={btnLink.aria}>{btnLink.label}</button>);
        }
      }

      return (<React.Fragment key={`text-fragment-${index}`}>{item}</React.Fragment>);
    });
  }

  return <p className={className}>{updatedTxt}</p>;
};

TextWithLinks.propTypes = {
  text: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      href: PropTypes.string,
      target: PropTypes.string,
      action: PropTypes.func,
      aria: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  className: PropTypes.string,
};

export default TextWithLinks;
